module.exports = __webpack_public_path__ + "static/img/dde3c55bdbbebaa770459d74f30a8ee2.careDetail2.1709800931122.png";